"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.5.2'] && _();
}
catch (e) { }
